var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignals2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 20,
    viewBox: "0 0 52 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5H5V15H2.5M6.66667 17.5H9.16667V11.6667H6.66667M10.8333 17.5H13.3333V7.5H10.8333M15 17.5H17.5V2.5H15V17.5Z",
    fill: "#4D94FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.667 17.5026V13.3359H32.0003V17.5026H28.667ZM29.5003 14.1693V16.6693H31.167V14.1693H29.5003ZM32.8337 17.5026V10.0026H36.167V17.5026H32.8337ZM33.667 10.8359V16.6693H35.3337V10.8359H33.667ZM37.0003 17.5026V6.66927H40.3337V17.5026H37.0003ZM37.8337 7.5026V16.6693H39.5003V7.5026H37.8337ZM41.167 17.5026V3.33594H44.5003V17.5026H41.167ZM42.0003 4.16927V16.6693H43.667V4.16927H42.0003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignals2);
export default __webpack_public_path__ + "static/media/Signals-2.838c8bb9c51361f370e8efc65a84b4fb.svg";
export { ForwardRef as ReactComponent };